




















































import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import {
  Claim
} from "@/shared/types";
import { formatCurrency } from "@/shared/currency.js";
import moment from "moment";
import { useClaimStore } from "@/employee/store/claim";

@Component({})
export default class HsabInsuranceClaim extends Vue {
  formatCurrency = formatCurrency;
  claimStore = useClaimStore();

  @Prop({required: true})
  linkedClaim: Claim;

  get claimLineCount (): number {
    if (this.linkedClaim && this.linkedClaim.claimLines) {
      return this.linkedClaim.claimLines.length;
    }
    return 0;
  }
  get formattedServiceDate () {
    return moment(this.linkedClaim.serviceDate).format("MMM DD, YYYY");
  }
  get claimLines () {
    return this.linkedClaim.claimLines;
  }
}
